// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalBackdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modalContainer {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    width: 600px;
  }
  
  .modalHeader {
    margin-top: 0;
    text-align: left;
    display: flex;
    align-items: center; 
    font-size: 18px;
    font-weight: bold;
  }
  .reportIssueIcon {
    margin-right: 8px; 
    margin-left: 5px;
    display: flex;
    align-items: center;
  }
  .formRow {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  
  .reportissueform-field {
    flex: 1 1;
  }
   
  .reportissueform-field:not(:last-child) {
    margin-right: 20px;
  }
  .reportIssueLabel {
    text-align: left;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    font-size:14px;
  }
  
  .buttonContainer {
    display: flex;
    justify-content: flex-end;
  }
  
  .reportIssueButton {
    padding: 6px 15px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    font-weight: bold;
    font-size:14px;
  }
   
  .reportIssueButton:first-child {
    background-color: #f44336;
    color: white;
  }
   
  .reportIssueButton:last-child {
    background-color: #4CAF50;
    color: white;
    margin-left: 20px;
  }
              
  .phone-input::placeholder {
    font-size: 12px; /* Set a custom font size */
  }
  .phone-input{
    border-radius: 4px;
    border: 1px solid lightgrey;
  }`, "",{"version":3,"sources":["webpack://./src/components/common/header/reportDialog.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe,EAAE,2BAA2B;EAC9C;EACA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B","sourcesContent":[".modalBackdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .modalContainer {\n    background: white;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n    width: 600px;\n  }\n  \n  .modalHeader {\n    margin-top: 0;\n    text-align: left;\n    display: flex;\n    align-items: center; \n    font-size: 18px;\n    font-weight: bold;\n  }\n  .reportIssueIcon {\n    margin-right: 8px; \n    margin-left: 5px;\n    display: flex;\n    align-items: center;\n  }\n  .formRow {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n  }\n  \n  .reportissueform-field {\n    flex: 1;\n  }\n   \n  .reportissueform-field:not(:last-child) {\n    margin-right: 20px;\n  }\n  .reportIssueLabel {\n    text-align: left;\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n    font-size:14px;\n  }\n  \n  .buttonContainer {\n    display: flex;\n    justify-content: flex-end;\n  }\n  \n  .reportIssueButton {\n    padding: 6px 15px;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    font-weight: bold;\n    font-size:14px;\n  }\n   \n  .reportIssueButton:first-child {\n    background-color: #f44336;\n    color: white;\n  }\n   \n  .reportIssueButton:last-child {\n    background-color: #4CAF50;\n    color: white;\n    margin-left: 20px;\n  }\n              \n  .phone-input::placeholder {\n    font-size: 12px; /* Set a custom font size */\n  }\n  .phone-input{\n    border-radius: 4px;\n    border: 1px solid lightgrey;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
